import styled from "styled-components";
import { colors } from "../common/element/elements.js";

export const Styles = styled.div`
    /* --- Modern Utility Top Bar --- */
    .top-bar-modern {
        background: #0c132f; /* Deep Navy */
        padding: 8px 0;
        font-size: 13px;

        .contact-info a {
            color: #d1d1d1;
            margin-right: 20px;
            text-decoration: none;
            transition: 0.3s;
            i { color: #ffc107; margin-right: 5px; }
            &:hover { color: #fff; }
        }

        .social-links {
            border-right: 1px solid rgba(255,255,255,0.1);
            padding-right: 15px;
            margin-right: 15px;
            a { color: #fff; margin: 0 8px; font-size: 14px; &:hover { color: #ffc107; }}
        }

        .lang-dropdown {
            .dropdown-toggle {
                background: transparent;
                border: none;
                color: #fff;
                font-size: 13px;
                padding: 0;
                margin-right: 20px;
                &::after { display: none; }
                i { color: #ffc107; font-size: 16px; margin-right: 4px; }
            }
            .dropdown-menu {
                border-radius: 8px;
                box-shadow: 0 10px 30px rgba(0,0,0,0.2);
            }
        }

        .auth-btn {
            background: rgba(255,255,255,0.1);
            border: 1px solid rgba(255,255,255,0.2);
            color: #fff;
            padding: 4px 12px;
            border-radius: 20px;
            font-size: 12px;
            transition: 0.3s;
            i { margin-right: 5px; }
            &:hover { background: #ffc107; color: #0c132f; border-color: #ffc107; }
        }
    }

    /* --- Main Floating Header --- */
    .main-header-area {
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(10px);
        box-shadow: 0 4px 20px rgba(0,0,0,0.05);
        padding: 10px 0;
        position: relative;
        z-index: 100;

        .header-inner-box {
            display: flex;
            align-items: center;
            justify-content: space-between;
        }

        .logo-brand a {
            display: flex;
            align-items: center;
            text-decoration: none;
            img { width: 75px; margin-right: 12px; transition: 0.3s; }
            .brand-text {
                h3 {
                    font-family: 'Rajdhani', sans-serif;
                    font-weight: 800;
                    font-size: 1.6rem;
                    margin: 0;
                    letter-spacing: 1px;
                }
                p {
                    font-size: 10px;
                    text-transform: uppercase;
                    margin: 0;
                    color: #666;
                    letter-spacing: 2px;
                    font-weight: 600;
                }
            }
        }

        .gradient-text {
            background: linear-gradient(90deg, #0C132F, #B8860F, #ffc107);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        /* Navigation Menu */
        .nav-list {
            display: flex;
            list-style: none;
            margin: 0;
            padding: 0;

            .nav-item {
                position: relative;
                padding: 10px 15px;

                a {
                    color: #0c132f;
                    font-weight: 600;
                    font-size: 14px;
                    text-transform: uppercase;
                    text-decoration: none;
                    transition: 0.3s;
                    position: relative;
                    
                    &::after {
                        content: '';
                        position: absolute;
                        bottom: -5px;
                        left: 0;
                        width: 0;
                        height: 2px;
                        background: #ffc107;
                        transition: 0.3s;
                    }
                }

                &:hover > a {
                    color: #B8860F;
                    &::after { width: 100%; }
                }

                /* Dropdown Logic */
                .dropdown-list {
                    position: absolute;
                    top: 100%;
                    left: 0;
                    background: #fff;
                    min-width: 240px;
                    box-shadow: 0 15px 40px rgba(0,0,0,0.1);
                    border-radius: 0 0 8px 8px;
                    list-style: none;
                    padding: 10px 0;
                    opacity: 0;
                    visibility: hidden;
                    transform: translateY(10px);
                    transition: 0.3s;
                    border-top: 3px solid #ffc107;

                    li a {
                        padding: 10px 20px;
                        display: block;
                        text-transform: capitalize;
                        color: #444;
                        font-weight: 500;
                        &::after { display: none; }
                        &:hover { background: #f8f9fa; color: #B8860F; padding-left: 25px; }
                    }
                }

                &:hover .dropdown-list {
                    opacity: 1;
                    visibility: visible;
                    transform: translateY(0);
                }
            }
        }

        /* Right Meta (Search, Register, Sidebar) */
        .header-right-meta {
            display: flex;
            align-items: center;

            .search-trigger {
                margin-right: 20px;
                i { font-size: 20px; color: #0c132f; cursor: pointer; transition: 0.3s; &:hover { color: #ffc107; }}
            }

            .register-pill {
                background: linear-gradient(90deg, #B8860F, #ffc107);
                color: #0c132f;
                padding: 8px 22px;
                border-radius: 30px;
                font-weight: 700;
                font-size: 13px;
                text-transform: uppercase;
                text-decoration: none;
                box-shadow: 0 4px 15px rgba(184, 134, 15, 0.3);
                transition: 0.3s;
                &:hover { transform: translateY(-2px); box-shadow: 0 6px 20px rgba(184, 134, 15, 0.4); color: #000; }
            }

            .sidebar-trigger {
                margin-left: 20px;
                font-size: 24px;
                color: #0c132f;
                cursor: pointer;
                transition: 0.3s;
                &:hover { color: #ffc107; }
            }
        }
    }

    /* --- MOBILE RESPONSIVENESS (Hide Desktop Header) --- */
    @media (max-width: 768px) {
        .top-bar-modern,
        .main-header-area {
            display: none !important;
        }
    }
`;